import Vue from 'vue'
import Router from 'vue-router'
import Index from '../pages/Index.vue'
import NewsList from '../pages/NewsList.vue'
import NewsDetail from '../pages/NewsDetail.vue'
import Content from '../pages/Content.vue'

import MobileIndex from '../pages/MobileIndex.vue'
import MobileContent from '../pages/MobileContent.vue'
import MobileNewsList from '../pages/MobileNewsList'
import MobileNewsDetail from '../pages/MobileNewsDetail'
import MobileIntent from "../pages/MobileIntent"

import MobileIntented from "../pages/MobileIntented"
import MobileIntentedList from "../pages/MobileIntentedList"
import MobileMyIntent from '../pages/MobileMyIntent.vue'
import MobileStore from '../pages/MobileStore.vue'
import MobileVerifyList from '../pages/MobileVerifyList.vue'

import MemberCard from '../pages/MemberCard.vue'

Vue.use(Router)

export default new Router({
  base: '/abc',
  mode: 'history',
  routes: [
    {
      path:'/',
      name:'Index',
      component: Index,
      children:[
        {
          path: 'content',
          name: 'Content',
          component: Content
        },
        {
          path: 'newsList',
          name: 'NewsList',
          component: NewsList
        },
        {
          path: 'newsDetail',
          name: 'NewsDetail',
          component: NewsDetail
        }
      ],
      redirect:'content'
    },
    {
      path: '/mobile',
      name: 'MobileIndex',
      component: MobileIndex,
      children: [
        {
          path: '/mobile/mcontent',
          name: 'MobileContent',
          component:MobileContent
        },{
          path: '/mobile/mobileNewsList',
          name: "MobileNewsList",
          component: MobileNewsList
        },{
          path: "/mobile/mobileNewsDetail",
          name: "MobileNewsDetail",
          component: MobileNewsDetail
        }
      ],
      redirect:'/mobile/mcontent'
    },
    {
      path: "/intent",
      name: "mobileIntent",
      component: MobileIntent
    },
    {
      path:"/intented",
      name: "mobileIntented",
      component: MobileIntented
    },
    {
      path:"/intentedList",
      name: "mobileIntentedList",
      component: MobileIntentedList
    },
    {
      path: "/myIntent",
      name: "myIntent",
      component:  MobileMyIntent
    },
    {
      path: "/store",
      name: "store",
      component:  MobileStore
    },
    {
      path: "/verifyList",
      name: "MobileVerifyList",
      component: MobileVerifyList
    },
    {
      path: "/memberCard",
      name: "MemberCard",
      component: MemberCard
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js